$(function(){
	$('.mask-cpf').mask('000.000.000-00', {reverse: false});
})